import { defineMessages } from 'react-intl-next';

import { goalStatusValues } from '../constants';

export const messages = defineMessages({
	[goalStatusValues.ON_TRACK]: {
		id: 'Goals.label.on-track',
		defaultMessage: 'On track',
		description: 'The label for the "on track" goal status',
	},
	[goalStatusValues.OFF_TRACK]: {
		id: 'Goals.label.off-track',
		defaultMessage: 'Off track',
		description: 'The label for the "off track" goal status',
	},
	[goalStatusValues.AT_RISK]: {
		id: 'Goals.label.at-risk',
		defaultMessage: 'At risk',
		description: 'The label for the "at risk" goal status',
	},
	[goalStatusValues.PENDING]: {
		id: 'Goals.label.pending',
		defaultMessage: 'Pending',
		description: 'The label for the "pending" goal status',
	},
	[goalStatusValues.COMPLETED]: {
		id: 'Goals.label.completed',
		defaultMessage: 'Completed',
		description: 'The label for the "completed" goal status',
	},
	[goalStatusValues.DONE]: {
		id: 'Goals.label.completed',
		defaultMessage: 'Completed',
		description: 'The label for the "completed" goal status',
	},
	[goalStatusValues.CANCELLED]: {
		id: 'Goals.label.cancelled',
		defaultMessage: 'Cancelled',
		description: 'The label for the "cancelled" goal status',
	},
	[goalStatusValues.PAUSED]: {
		id: 'Goals.label.paused',
		defaultMessage: 'Paused',
		description: 'The label for the "paused" goal status',
	},
	[goalStatusValues.ARCHIVED]: {
		id: 'Goals.label.archived',
		defaultMessage: 'Archived',
		description: 'The label for the "archived" goal status',
	},
});
